import { schemes, worker_types } from "@zeal/common";
import { z } from "zod";

export const postArchiveWorkerBankAccountRequestSchema = z.object({
  bank_account_id: z.string(),
  companyID: schemes.companyID(),
  workerID: schemes.mongoObjectId(),
  worker_type: z.nativeEnum(worker_types),
});

export type TPostArchiveWorkerBankAccountRequest = z.infer<
  typeof postArchiveWorkerBankAccountRequestSchema
>;
